import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const STORAGE_KEY = "app_locale";
const SUPPORTED = ["es", "en"];
const DEFAULT_LOCALE = "en";
// English-only mode: when true, the locale is permanently "en" and all
// language toggles are hidden. Flip to false to re-enable the EN/ES switcher.
const ENGLISH_ONLY_MODE = true;
export const ENGLISH_ONLY = ENGLISH_ONLY_MODE;

const dict = {
  es: {
    // Common
    "common.back": "Volver",
    "common.cancel": "Cancelar",
    "common.save": "Guardar",
    "common.delete": "Eliminar",
    "common.create": "Crear",
    "common.add": "Agregar",
    "common.edit": "Editar",
    "common.continue": "Continuar",
    "common.confirm": "Confirmar",
    "common.next": "Siguiente",
    "common.previous": "Anterior",
    "common.finish": "Terminar",
    "common.loading": "Cargando...",
    "common.generating": "Generando...",
    "common.empty": "Aún no hay contenido aquí.",
    "common.search": "Buscar",
    "common.profile": "Perfil",
    "common.settings": "Ajustes",
    "common.welcome": "Bienvenido",
    "common.error": "Error",
    "common.success": "¡Listo!",
    "common.coming_soon": "Pronto",
    "common.see_more": "Ver más",
    "common.see_less": "Ver menos",
    "common.try_again": "Intentar de nuevo",
    "common.close": "Cerrar",
    "common.yes": "Sí",
    "common.no": "No",

    // Topbar / Sidebar
    "brand.subtitle": "Mueblería",
    "brand.title": "Canales · Escuela",
    "topbar.admin_view": "Vista de Administrador",
    "topbar.platform": "Plataforma de Capacitación",
    "topbar.admin_badge": "Admin",
    "topbar.ai_suggestion": "Sugerencia IA",
    "topbar.language_toggle_aria": "Cambiar idioma",

    "sidebar.group.admin": "Administración",
    "sidebar.group.learning": "Aprendizaje",
    "sidebar.group.operations": "Operación",
    "sidebar.group.culture": "Cultura y Estrategia",
    "sidebar.group.people": "Personas",

    "nav.admin": "Panel general",
    "nav.assignments": "Asignaciones · IA",
    "nav.dashboard": "Inicio",
    "nav.courses_admin": "Cursos",
    "nav.library": "Biblioteca",
    "nav.processes": "Procesos",
    "nav.community": "Comunidad",
    "nav.languages": "Idiomas",
    "nav.languages_admin": "Idiomas (admin)",
    "nav.financing": "Financiamiento",
    "nav.motivation": "Motivación",
    "nav.leadership": "Liderazgo",
    "nav.strategy": "Estrategia",
    "nav.rewards": "Recompensas",
    "nav.evaluations": "Evaluaciones",
    "nav.mgr_eval": "Eval. Managers",
    "nav.my_team": "Mi equipo",
    "nav.sms": "Notif. SMS",

    "user.role.admin": "Administrador",
    "user.role.salesperson": "Vendedor",
    "user.logout": "Cerrar sesión",

    // Languages module
    "lang.hero.eyebrow": "Nuevo módulo · Canales Language School",
    "lang.hero.title": "Aprende idiomas jugando.",
    "lang.hero.subtitle":
      "Cruza barreras con clientes en inglés, francés o español. Lecciones cortas, personajes que te guían y puntos que suman a tus recompensas.",
    "lang.feature.lessons": "9 lecciones",
    "lang.feature.voice": "Conversación IA por voz",
    "lang.feature.streaks": "Rachas diarias",
    "lang.feature.badges": "7 insignias",
    "lang.section.guide.eyebrow": "Tu guía",
    "lang.section.guide.title": "Elige tu personaje",
    "lang.section.guide.note": "Puedes cambiarlo cuando quieras.",
    "lang.section.catalog.eyebrow": "Catálogo",
    "lang.section.catalog.title": "Elige un idioma",
    "lang.character.active": "Activo",
    "lang.lessons_progress": "{completed}/{total} lecciones",
    "lang.plan.eyebrow": "Tu plan personalizado",
    "lang.plan.coach_label": "Mensaje de tu coach",
    "lang.plan.minutes_per_week": "Min/sem",
    "lang.plan.lessons_per_week": "Lecciones/sem",
    "lang.plan.next_lessons": "Próx. lecciones",
    "lang.plan.scenario": "Escenario",
    "lang.plan.scenario_value": "Voz IA",
    "lang.plan.reconfigure": "Reconfigurar mi plan",

    "lang.hud.xp_total": "XP total",
    "lang.hud.coins": "Monedas",
    "lang.hud.streak": "Racha",
    "lang.hud.streak_days": "{n} día{plural}",
    "lang.hud.level": "Nivel {n}",
    "lang.hud.xp_to_next": "{xp} XP al nivel {next}",

    "lang.map.back": "Volver a idiomas",
    "lang.map.title": "Tu ruta de aprendizaje",
    "lang.map.subtitle": "Cada lección tiene ejercicios cortos. Completa una para desbloquear la siguiente.",
    "lang.map.world_label": "Mundo {n}",
    "lang.map.world_complete": "Completo",
    "lang.map.lesson_label": "Lección {n}",
    "lang.map.cta.eyebrow": "Nuevo · IA por voz",
    "lang.map.cta.title": "Conversa con la IA en {lang}",
    "lang.map.cta.subtitle": "Habla. Te responde. Te corrige al instante. Como un FaceTime con tu coach.",
    "lang.map.world.ciudad": "La Ciudad",
    "lang.map.world.restaurante": "El Restaurante",
    "lang.map.world.viaje": "De Viaje",
    "lang.map.materials.eyebrow": "Curado por tu equipo",
    "lang.map.materials.title": "Material adicional",
    "lang.map.material.ai_exam": "Examen IA al final",
    "lang.map.material.completed": "Completado",

    // Lesson
    "lesson.kind.translate_multiple": "Traduce · opción múltiple",
    "lesson.kind.listen_choose": "Escucha y elige",
    "lesson.kind.type_answer": "Escribe la traducción",
    "lesson.kind.match_pairs": "Une las palabras",
    "lesson.kind.order_words": "Ordena las palabras",
    "lesson.verify": "Verificar",
    "lesson.show_hint": "Ver pista",
    "lesson.hide_hint": "Ocultar pista",
    "lesson.feedback.correct": "¡Correcto!",
    "lesson.feedback.wrong": "Respuesta",
    "lesson.feedback.right_answer": "La respuesta correcta es:",
    "lesson.listen_button": "Escuchar",
    "lesson.listen_help": "Tu navegador lee la palabra. Sube el volumen y toca el botón para repetir.",
    "lesson.type_placeholder": "Escribe tu respuesta...",
    "lesson.type_help": "Aceptamos con y sin acentos.",
    "lesson.order_help": "Toca las palabras de abajo en orden...",
    "lesson.match.reset": "Reiniciar",
    "lesson.coach.thinking": "Pensando una pista para ti...",

    "lesson.results.completed": "Lección completada",
    "lesson.results.perfect": "¡Perfecto!",
    "lesson.results.passed": "¡Bien hecho!",
    "lesson.results.failed": "Sigue practicando",
    "lesson.results.correct": "Aciertos",
    "lesson.results.accuracy": "Precisión",
    "lesson.results.xp": "XP",
    "lesson.results.coins": "{n} monedas",
    "lesson.results.streak": "Racha: {n} día{plural}",
    "lesson.results.global_pts": "{n} pts globales",
    "lesson.results.new_badges": "¡Nuevas insignias!",
    "lesson.results.world_complete": "🗺️ ¡Completaste un mundo entero!",
    "lesson.results.back": "Volver al mapa",
    "lesson.results.retry": "Reintentar",
    "lesson.results.review": "Ver repaso ({n} ejercicios)",
    "lesson.results.your_answer": "Tu respuesta:",
    "lesson.results.right_answer": "Correcta:",
    "lesson.results.no_answer": "(sin respuesta)",

    // Conversation
    "conv.picker.eyebrow": "Conversación con IA · Voz",
    "conv.picker.title": "Habla. La IA te responde y te corrige.",
    "conv.picker.subtitle": "Elige un escenario, presiona el micrófono y conversa en {lang} como si fuera real. Tu coach te dará feedback al instante.",
    "conv.picker.tag_browser": "Web Speech (Chrome/Edge/Safari)",
    "conv.picker.tag_pts": "+20 pts globales por sesión",
    "conv.picker.starting": "Iniciando con tu coach...",
    "conv.chat.exit": "Salir",
    "conv.chat.end": "Terminar y ver resumen",
    "conv.chat.eyebrow": "Conversación · {lang}",
    "conv.chat.subtitle": "Habla con tu coach. Te responde y corrige al instante.",
    "conv.chat.coach_lang": "Coach · en {lang}",
    "conv.chat.score": "Score:",
    "conv.chat.suggestions": "Sugerencias para responder",
    "conv.chat.recording": "Grabando... habla con claridad",
    "conv.chat.transcribed": "Escuchaste bien. Toca enviar o vuelve a grabar.",
    "conv.chat.idle": "Toca el micrófono y di tu respuesta.",
    "conv.chat.send": "Enviar",
    "conv.chat.no_mic": "¿Sin micrófono?",
    "conv.chat.switch_text": "Escribe en lugar de hablar",
    "conv.chat.placeholder": "Escribe tu respuesta...",
    "conv.chat.thinking": "Tu coach está respondiendo...",
    "conv.chat.voice_picker": "Voz IA",
    "conv.chat.voice_pick_label": "Elige la voz del coach",
    "conv.chat.voice_none": "Tu navegador no expuso voces para este idioma.",
    "conv.summary.eyebrow": "Sesión finalizada",
    "conv.summary.title": "¡Buen trabajo!",
    "conv.summary.turns": "Turnos",
    "conv.summary.score": "Score",
    "conv.summary.xp": "XP",
    "conv.summary.global_pts": "+{n} puntos globales",
    "conv.summary.strengths": "Fortalezas",
    "conv.summary.improve": "Mejorar",
    "conv.summary.back": "Volver al mapa",

    // Onboarding
    "onb.step1.title": "¿Qué edad tienes?",
    "onb.step1.subtitle": "Esto nos ayuda a personalizar el tono.",
    "onb.step2.title": "¿Qué idioma quieres practicar?",
    "onb.step2.subtitle": "Puedes cambiarlo más adelante.",
    "onb.step3.title": "¿Qué te motiva más?",
    "onb.step3.subtitle": "Adaptaremos las prácticas a tu objetivo.",
    "onb.step4.title": "¿Qué tan cómodo te sientes hablando?",
    "onb.step4.subtitle": "Sé honesto, no hay respuestas malas.",
    "onb.step5.title": "¿Cuántos minutos al día puedes practicar?",
    "onb.step5.subtitle": "Pequeño y constante gana.",
    "onb.step6.title": "Elige tu coach",
    "onb.step6.subtitle": "El personaje que te acompañará en tu viaje.",
    "onb.last_hint": "Último paso. Tu coach se prepara para ti.",
    "onb.helper": "Tus respuestas crean un plan único en segundos.",
    "onb.cta.next": "Siguiente",
    "onb.cta.generate": "Generar mi plan",
    "onb.cta.generating": "Generando con IA...",
    "onb.plan.eyebrow": "Plan generado por IA",
    "onb.plan.title": "Tu camino está listo.",
    "onb.plan.minutes_week": "Min/semana",
    "onb.plan.lessons_week": "Lecciones/semana",
    "onb.plan.milestones": "Tus primeras metas",
    "onb.plan.start": "Empezar mi viaje",

    "onb.opt.age.18-24": "18 a 24 años",
    "onb.opt.age.25-34": "25 a 34 años",
    "onb.opt.age.35-44": "35 a 44 años",
    "onb.opt.age.45+": "45 años o más",
    "onb.opt.lang.en": "🇺🇸 Inglés",
    "onb.opt.lang.fr": "🇫🇷 Francés",
    "onb.opt.lang.es": "🇪🇸 Español",
    "onb.opt.motiv.atender_clientes": "Atender clientes extranjeros en la mueblería 🛋️",
    "onb.opt.motiv.cerrar_ventas": "Cerrar más ventas con clientes que no hablan español 💼",
    "onb.opt.motiv.viajar": "Viajar y desenvolverte en el extranjero ✈️",
    "onb.opt.motiv.curiosidad": "Curiosidad personal y crecimiento 🌱",
    "onb.opt.level.principiante": "Principiante · empiezo desde cero",
    "onb.opt.level.intermedio": "Intermedio · me defiendo",
    "onb.opt.level.avanzado": "Avanzado · solo quiero pulir",
    "onb.opt.minutes.5": "5 minutos · solo lo justo",
    "onb.opt.minutes.10": "10 minutos · cómodo",
    "onb.opt.minutes.15": "15 minutos · enfocado",
    "onb.opt.minutes.30": "30 minutos · maratón",

    // Material + quiz
    "mat.material": "Material",
    "mat.back_to_map": "Volver al mapa",
    "mat.completed_label": "Material completado",
    "mat.completed_hint": "¿Listo para verificar tu comprensión con un examen IA?",
    "mat.start_quiz": "Terminé · examen IA · 15 preguntas",
    "mat.start_quiz_done": "Tomar examen IA · 15 preguntas",
    "mat.generating": "Generando examen IA...",
    "mat.open_external": "Abrir en pestaña nueva",
    "mat.open_link": "Abrir enlace externo",
    "mat.quiz.eyebrow": "Examen generado por IA",
    "mat.quiz.q_label": "Pregunta {i}/{total}",
    "mat.quiz.answered_count": "{answered}/{total} respondidas",
    "mat.quiz.submit": "Entregar examen",
    "mat.quiz.result.title.perfect": "¡Perfecto!",
    "mat.quiz.result.title.passed": "¡Aprobaste!",
    "mat.quiz.result.title.failed": "Sigue estudiando",
    "mat.quiz.result.review": "Ver repaso ({n})",

    // Sections (Motivacion / Liderazgo / Estrategia)
    "section.daily_quote.label": "Frase del día",
    "section.weekly.label": "Reflexión de la semana · IA",
    "section.empty.title": "Aún no hay materiales en {section}.",
    "section.empty.admin": "Sube el primer material desde el formulario de arriba.",
    "section.empty.user": "Pronto el equipo cargará contenido aquí.",
    "section.mark_read": "+5 pts",
    "section.read": "Leído",
    "section.mark_read_title_done": "Leído",
    "section.mark_read_title_undone": "Marcar como leído (+5 pts)",

    // Admin Languages
    "adm_lang.eyebrow": "Idiomas · Material adicional",
    "adm_lang.title": "Sube material para tu equipo.",
    "adm_lang.subtitle":
      "Comparte PDFs, videos, enlaces o notas por idioma. Los vendedores los verán como \"Material adicional\" en el mapa del idioma. Al terminar un video, la IA puede generar un examen de 15 preguntas basado en el resumen.",
    "adm_lang.tab.en": "🇺🇸 Inglés",
    "adm_lang.tab.fr": "🇫🇷 Francés",
    "adm_lang.tab.es": "🇪🇸 Español",
    "adm_lang.list_label": "Materiales en {lang} · {n}",
    "adm_lang.empty": "Aún no hay materiales para este idioma. Sube el primero arriba.",
    "adm_lang.upload_in": "Subir material en {lang}",
    "adm_lang.field.title": "Título",
    "adm_lang.field.desc": "Descripción breve (opcional, ayuda a generar el examen IA)",
    "adm_lang.field.body": "Contenido de la nota...",
    "adm_lang.field.transcript_label": "Resumen / transcripción del video (recomendado)",
    "adm_lang.field.transcript_placeholder":
      "Pega aquí el resumen o transcripción del video. La IA generará un examen de 15 preguntas basado en este texto. Si lo dejas vacío, las preguntas serán generales del título y descripción.",
    "adm_lang.field.url_external": "URL https://...",
    "adm_lang.field.url_video": "URL https://... (YouTube, Vimeo, etc.)",
    "adm_lang.upload_choose": "Subir archivo",
    "adm_lang.upload_url": "URL externa",
    "adm_lang.uploading": "Subiendo...",
    "adm_lang.upload_done": "Listo",
    "adm_lang.has_transcript": "Tiene transcripción · examen IA listo",
    "adm_lang.type.video": "Video",
    "adm_lang.type.pdf": "PDF",
    "adm_lang.type.link": "Enlace",
    "adm_lang.type.note": "Nota / texto",
    "adm_lang.confirm_delete": "¿Eliminar este material? También se borra su examen IA cacheado.",

    // Evaluations (vendedor / admin)
    "eval.user.eyebrow": "Evaluaciones",
    "eval.user.title": "Tus exámenes asignados.",
    "eval.user.subtitle": "Responde los exámenes que te asignó tu administrador. Al terminar, recibirás un resumen IA con tus fortalezas y áreas a mejorar.",
    "eval.user.empty": "Aún no tienes evaluaciones asignadas. Cuando tu admin te asigne una, aparecerá aquí.",
    "eval.user.pending": "Pendientes",
    "eval.user.completed": "Completadas",
    "eval.user.no_pending": "No tienes pendientes. ¡Bien hecho!",
    "eval.user.pending_badge": "Pendiente",
    "eval.user.start": "Comenzar",
    "eval.user.retake": "Volver a intentar",
    "eval.questions": "preguntas",
    "eval.question": "Pregunta",
    "eval.runner.eyebrow": "Examen en curso",
    "eval.runner.answered": "Respondidas",
    "eval.submit": "Enviar examen",
    "eval.confirm_unanswered": "Tienes {n} pregunta(s) sin responder. ¿Enviar de todos modos?",
    "eval.open_placeholder": "Escribe tu respuesta aquí...",
    "eval.type.multiple_choice": "Opción múltiple",
    "eval.type.scale": "Escala 1-5",
    "eval.type.open": "Pregunta abierta",
    "eval.result.passed": "¡Aprobado! Excelente trabajo.",
    "eval.result.failed": "No aprobado. Repasa y vuelve a intentarlo.",
    "eval.result.qualitative": "Resultado registrado · evaluación cualitativa",
    "eval.points_awarded": "puntos",
    "eval.ai_summary": "Resumen IA personalizado",
    "eval.strengths": "Fortalezas",
    "eval.to_improve": "A mejorar",
    "eval.review_details": "Ver desglose por pregunta",
    "eval.correct": "Correcta",
    "eval.incorrect": "Incorrecta",
    "eval.answer_recorded": "Respuesta registrada",
    "eval.back_to_list": "Volver al listado",

    // Manager team dashboard
    "manager.team.eyebrow": "Mi equipo",
    "manager.team.title": "Tus vendedores y su avance.",
    "manager.team.subtitle": "Mira en un vistazo cómo va cada vendedor que reporta a ti: evaluaciones completadas, promedio, cursos aprobados y resumen IA del último examen.",
    "manager.team.kpi_size": "Vendedores",
    "manager.team.kpi_evals": "Eval. completadas",
    "manager.team.kpi_avg": "Promedio del equipo",
    "manager.team.col_evals": "Evals.",
    "manager.team.col_avg": "Promedio",
    "manager.team.col_courses": "Cursos OK",
    "manager.team.last_eval": "Última evaluación",
    "manager.team.list_label": "Equipo a tu cargo",
    "manager.team.empty": "Aún no tienes vendedores asignados.",
    "manager.team.empty_hint": "Pídele al admin que te asigne tu equipo desde Vendedores y avance → Editar → Reporta a.",

    // Vendedor dashboard widget · evaluaciones pendientes
    "widget.eval.eyebrow": "Tu manager te asignó",
    "widget.eval.title": "{n} evaluación(es) pendiente(s)",
    "widget.eval.subtitle": "Tu manager está esperando tus resultados. Termínalas para ganar puntos y mostrar tu avance.",
    "widget.eval.go": "Comenzar",
    "widget.eval.manager": "Para managers",

    // Admin SMS page
    "sms.eyebrow": "Notificaciones SMS",
    "sms.title": "Avisos por SMS al equipo de dirección.",
    "sms.subtitle": "Cada login, curso completado y meta de 100 puntos dispara un SMS a los números configurados. Útil para que dirección esté al tanto sin abrir la plataforma.",
    "sms.status_active": "Twilio activo · enviando SMS reales",
    "sms.status_active_desc": "Las credenciales de Twilio están configuradas. Cada disparo envía SMS reales y deja registro en el historial.",
    "sms.status_mock": "Modo simulación · sin credenciales Twilio",
    "sms.status_mock_desc": "Los SMS se registran en el historial como 'mocked' pero NO se envían. Agrega tus credenciales de Twilio en backend/.env para activar:",
    "sms.on": "Activado",
    "sms.off": "Pausado",
    "sms.enabled": "SMS activados",
    "sms.disabled": "SMS pausados",
    "sms.kpi_sent": "Enviados real",
    "sms.kpi_mocked": "Simulados",
    "sms.kpi_error": "Errores",
    "sms.recipients_label": "Destinatarios",
    "sms.recipients_title": "¿Quién recibe los avisos?",
    "sms.recipients_desc": "Cada SMS viaja a TODOS los números de la lista. Formato E.164 (+ país + número, sin espacios).",
    "sms.no_recipients": "No hay números configurados. Agrega al menos uno para que los SMS funcionen.",
    "sms.add": "Agregar",
    "sms.remove": "Eliminar",
    "sms.format_hint": "Ejemplo: +19172663595 · acepta también con espacios o guiones, se normalizan al guardar.",
    "sms.phone_added": "Número agregado",
    "sms.phone_removed": "Número eliminado",
    "sms.confirm_remove": "¿Eliminar este número de la lista de avisos?",
    "sms.test_label": "Prueba rápida",
    "sms.test_title": "Enviar SMS de prueba a todos los números",
    "sms.send_test": "Enviar prueba",
    "sms.test_sent": "Prueba enviada · revisa el historial",
    "sms.history_label": "Historial · últimos 100 SMS",
    "sms.history_empty": "Aún no hay SMS registrados. Inicia sesión, completa un curso o usa el botón de prueba.",
    "sms.col_time": "Fecha",
    "sms.col_kind": "Tipo",
    "sms.col_to": "Para",
    "sms.col_status": "Estado",
    "sms.col_body": "Mensaje",
    "sms.select_all": "Seleccionar todos",
    "sms.select_row": "Seleccionar esta fila",
    "sms.delete_row": "Eliminar este registro",
    "sms.delete_selected": "Eliminar seleccionados",
    "sms.clear_selection": "Quitar selección",
    "sms.clear_all": "Limpiar todo",
    "sms.n_selected": "{n} seleccionado(s)",
    "sms.confirm_delete_one": "¿Eliminar este registro del historial?",
    "sms.confirm_delete_bulk": "¿Eliminar {n} registros del historial?",
    "sms.confirm_clear_all": "¿Borrar TODO el historial de SMS? Esta acción no se puede deshacer.",
    "sms.deleted_one": "Registro eliminado",
    "sms.deleted_bulk": "{n} registro(s) eliminado(s)",
    "common.refresh": "Actualizar",

    // Login
    "login.eyebrow_left": "Escuela Interna de Ventas",
    "login.hero_title": "Forma vendedores que cierran con confianza.",
    "login.hero_subtitle": "Una plataforma diseñada para estandarizar la capacitación, medir el dominio del piso de ventas y elevar el desempeño de cada asesor en Mueblería Canales.",
    "login.footer_left": "Capacitación Interna",
    "login.team_access": "Acceso al equipo",
    "login.welcome_back": "Bienvenido de nuevo.",
    "login.welcome_subtitle": "Inicia sesión con tu cuenta de Google para continuar tu capacitación.",
    "login.google_btn": "Continuar con Google",
    "login.or": "o",
    "login.admin_btn": "Acceso administrador con contraseña",
    "login.help_text": "Vendedores entran con Google. Administradores con cuenta institucional entran con el botón \"Acceso administrador con contraseña\".",
    "login.legal_prefix": "Al iniciar sesión aceptas el",
    "login.legal_and": "y los",
    "login.legal_suffix": "de la plataforma de capacitación de Mueblería Canales.",
    "login.privacy_link": "Aviso de Privacidad",
    "login.terms_link": "Términos y Condiciones",

    // Admin Dashboard
    "admin.eyebrow": "Panel administrativo",
    "admin.hero_title": "Resultados del equipo de ventas.",
    "admin.hero_subtitle": "Crea cursos, sube videos y PDFs, configura exámenes y revisa el avance de cada vendedor.",
    "admin.team_eyebrow": "Equipo",
    "admin.team_heading": "Vendedores y avance",
    "admin.approvals": "Aprobaciones",
    "admin.create_user": "Crear usuario",

    // Manual PDF card
    "manual.eyebrow": "3 manuales por rol",
    "manual.title": "Manuales en PDF",
    "manual.last_update": "Última actualización",
    "manual.locale_label": "Idioma del PDF",
    "manual.locale_hint": "Elige el idioma en el que se generará el texto de los manuales y las capturas.",
    "manual.step.seeding": "Preparando datos demo...",
    "manual.step.capturing": "Capturando pantallas (≈40s)...",
    "manual.step.rendering": "Generando PDF...",
    "manual.step.cleanup": "Limpiando...",
    "manual.step_progress": "Paso {step}/{total}",
    "manual.screenshots": "{n} capturas",
    "manual.error_title": "Última regeneración falló",
    "manual.ok_ready": "Generado correctamente",
    "manual.generating": "Generando...",
    "manual.rebuild_btn": "Regenerar los 3 PDFs ({lang})",
    "manual.rebuild_btn_title": "Regenerar capturando pantallas actuales en el idioma elegido",
    "manual.confirm_rebuild": "¿Regenerar los 3 manuales en {lang} ahora?\n\nEsto toma ~60 segundos: el sistema toma capturas nuevas en el idioma elegido y arma los PDFs. Los archivos actuales siguen disponibles mientras se genera el nuevo.",
    "manual.rebuild_started": "Regeneración iniciada · ~60 segundos",
    "manual.rebuild_error": "Error al iniciar regeneración",

    // Admin Settings (manual user creation)
    "settings.eyebrow": "Configuración del administrador",
    "settings.title": "Ajustes de Admin",
    "settings.subtitle": "Hola {name}, desde aquí puedes agregar manualmente nuevos usuarios y asignarles permisos. Cada rol tiene un conjunto de permisos predefinidos.",
    "settings.you": "Sesión activa",
    "settings.back": "Volver al panel",
    "settings.add.title": "Agregar nuevo usuario",
    "settings.add.subtitle": "Completa los 3 pasos. Los permisos se asignan automáticamente según el rol que elijas.",
    "settings.step": "Paso {n}",
    "settings.identity": "Datos del usuario",
    "settings.field.role": "Rol del usuario",
    "settings.field.name": "Nombre completo",
    "settings.field.email": "Correo electrónico",
    "settings.field.password": "Contraseña inicial",
    "settings.field.password_hint": "Mínimo 6 caracteres. Comparte esta clave de forma segura con el usuario.",
    "settings.field.phone": "Teléfono (opcional, formato E.164)",
    "settings.field.phone_hint": "Solo se usa para notificaciones SMS internas. Ejemplo: +18175551234.",
    "settings.field.reports_to": "Reporta a (manager)",
    "settings.field.reports_to_hint": "Si dejas vacío, el vendedor podrá ser asignado más tarde desde el panel.",
    "settings.no_manager": "— Sin manager asignado por ahora —",
    "settings.regen": "Generar otra",
    "settings.clear": "Limpiar",
    "settings.creating": "Creando...",
    "settings.add_btn": "Crear como {role}",
    "settings.created_ok": "{name} fue creado correctamente",
    "settings.created_eyebrow": "Usuario creado",
    "settings.created_role": "Rol asignado",
    "settings.created_password": "Contraseña inicial",
    "settings.created_password_hint": "Cópiala ahora — por seguridad no se mostrará de nuevo.",
    "settings.creds_send_btn": "Enviar credenciales por correo",
    "settings.creds_send_hint": "El usuario recibirá un correo con su email y contraseña inicial. Podrá iniciar sesión de inmediato.",
    "settings.creds_sending": "Enviando...",
    "settings.creds_sent": "Credenciales enviadas a {email}",
    "settings.creds_mocked": "Correo registrado (modo simulación · configura Resend para enviar real)",
    "settings.creds_sent_badge": "Correo de credenciales enviado",
    "settings.creds_error": "No se pudo enviar el correo de credenciales",
    "settings.dismiss": "Cerrar este aviso",
    "settings.legend_eyebrow": "Roles disponibles",
    "settings.legend_title": "¿Qué hace cada rol?",
    "settings.permissions_title": "Permisos asignados automáticamente",
    "settings.full_table_hint": "Para ver y editar usuarios existentes, abre el dashboard.",
    "settings.go_to_dashboard": "Ir al dashboard",
    "settings.err.name": "El nombre completo es obligatorio",
    "settings.err.email": "Correo inválido. Usa el formato nombre@dominio.com",
    "settings.err.password": "La contraseña debe tener al menos 6 caracteres",
    "settings.err.create": "No se pudo crear el usuario",
    // Role descriptions
    "settings.role.admin.title": "Administrador",
    "settings.role.admin.tagline": "Control total de la plataforma.",
    "settings.role.admin.legend": "Configura cursos, evaluaciones, usuarios, SMS y notificaciones. Tiene acceso ilimitado.",
    "settings.role.admin.perm_1": "Crear, editar y eliminar cursos, evaluaciones y materiales.",
    "settings.role.admin.perm_2": "Crear, editar y eliminar usuarios (cualquier rol).",
    "settings.role.admin.perm_3": "Aprobar managers y configurar destinatarios SMS.",
    "settings.role.admin.perm_4": "Ver estadísticas globales y resúmenes IA de todo el equipo.",
    "settings.role.manager.title": "Manager",
    "settings.role.manager.tagline": "Lidera y acompaña vendedores.",
    "settings.role.manager.legend": "Ve avance de su equipo, recibe correos con resúmenes IA y toma cursos como vendedor.",
    "settings.role.manager.perm_1": "Ver \"Mi equipo\" con avance, promedios y resúmenes IA.",
    "settings.role.manager.perm_2": "Recibir correo automático cuando un vendedor termina una evaluación.",
    "settings.role.manager.perm_3": "Tomar cursos, evaluaciones y ganar puntos como cualquier vendedor.",
    "settings.role.manager.perm_4": "Sin acceso a creación de cursos, usuarios ni configuración.",
    "settings.role.sales.title": "Vendedor",
    "settings.role.sales.tagline": "Aprende, evalúa, gana puntos.",
    "settings.role.sales.legend": "Toma cursos, presenta evaluaciones, practica idiomas y canjea recompensas.",
    "settings.role.sales.perm_1": "Tomar cursos asignados y presentar evaluaciones.",
    "settings.role.sales.perm_2": "Ganar puntos y canjear recompensas del catálogo.",
    "settings.role.sales.perm_3": "Practicar idiomas con asistente IA y conversación por voz.",
    "settings.role.sales.perm_4": "Visualizar su propio avance y certificados.",

    // Dashboards section headers
    "dashboard.eyebrow.catalog": "Catálogo",
    "dashboard.title.modules": "Módulos de capacitación",
    "dashboard.kpi.available_courses": "Cursos disponibles",
    "dashboard.kpi.passed_courses": "Cursos aprobados",
    "dashboard.kpi.exam_average": "Promedio en exámenes",
    "dashboard.weak.eyebrow": "Áreas a mejorar",
    "dashboard.weak.recommend": "Te recomendamos revisar:",
    "dashboard.empty_courses": "Aún no hay cursos disponibles.",
    "dashboard.add_module": "Adherir módulo",
    "dashboard.loading_courses": "Cargando cursos...",
    "dashboard.hero.greeting": "Hola, {name}",
    "dashboard.hero.title": "Tu camino de capacitación.",
    "dashboard.hero.body": "Estudia los módulos a tu ritmo, presenta los exámenes y mide tu avance en cada uno de los temas clave del piso de ventas en Mueblería Canales.",

    "admin.eyebrow.shortcuts": "Atajos del admin",
    "admin.title.shortcuts": "Adherir contenido a otras secciones",
    "admin.eyebrow.catalog": "Catálogo",
    "admin.title.catalog": "Módulos de capacitación",
    "admin.eyebrow.recognition": "Reconocimiento",
    "admin.title.top_sales": "Top vendedores",

    // Rewards section
    "rewards.eyebrow.history": "Historial",
    "rewards.title.my_redemptions": "Mis canjes",
    "rewards.col.reward": "Premio",
    "rewards.col.points": "Puntos",
    "rewards.col.date": "Fecha",
    "rewards.col.status": "Estado",

    // ContentHub section
    "content.eyebrow.materials": "Materiales",
    "content.title.team_resources": "{section} · Recursos del equipo",

    // Change password page
    "pwd.title": "Cambiar contraseña",
    "pwd.current": "Contraseña actual",
    "pwd.current.placeholder_forced": "La que te compartió el administrador",
    "pwd.new": "Nueva contraseña",
    "pwd.new.hint": "Mínimo 6 caracteres. Usa mayúsculas, números y símbolos para mayor seguridad.",
    "pwd.confirm": "Confirmar nueva contraseña",
    "pwd.match_ok": "Las contraseñas coinciden",
    "pwd.save": "Guardar contraseña",
    "pwd.saving": "Guardando...",
    "pwd.cancel": "Cancelar",
    "pwd.ok": "Contraseña actualizada correctamente",
    "pwd.err.too_short": "La nueva contraseña debe tener al menos 6 caracteres",
    "pwd.err.mismatch": "Las contraseñas no coinciden",
    "pwd.err.same_as_current": "La nueva contraseña debe ser distinta a la actual",
    "pwd.err.generic": "No se pudo actualizar la contraseña",
    "pwd.strength.weak": "Débil",
    "pwd.strength.ok": "Aceptable",
    "pwd.strength.strong": "Fuerte",
    "pwd.forced.title": "Primer inicio de sesión",
    "pwd.forced.subtitle": "Por seguridad, cambia la contraseña que te compartió el administrador antes de continuar.",

    // Forgot password
    "forgot.title": "Restablecer contraseña",
    "forgot.subtitle": "Ingresa tu correo y te enviaremos un enlace para crear una nueva contraseña.",
    "forgot.email": "Correo electrónico",
    "forgot.submit": "Enviar enlace",
    "forgot.sending": "Enviando...",
    "forgot.back": "Volver al inicio de sesión",
    "forgot.privacy": "Por privacidad, siempre verás esta confirmación, exista o no la cuenta. Si tu correo está registrado, recibirás el enlace en unos minutos.",
    "forgot.err.email": "Ingresa un correo válido",
    "forgot.sent.title": "Revisa tu correo",
    "forgot.sent.body": "Si {email} corresponde a una cuenta válida, te enviamos un enlace para crear una nueva contraseña. El enlace expira en 60 minutos.",
    "forgot.sent.hint": "Recuerda revisar también tu carpeta de spam si no lo ves en la bandeja de entrada.",
    "forgot.resend": "Enviar a otro correo",
    "forgot.go_login": "Ir al inicio de sesión",

    // Reset password (token landing)
    "reset.title": "Crear nueva contraseña",
    "reset.submit": "Guardar y continuar",
    "reset.validating": "Validando enlace...",
    "reset.invalid.title": "Enlace inválido o expirado",
    "reset.request_new": "Solicitar uno nuevo",
    "reset.notice": "Al guardar la nueva contraseña, todas tus sesiones activas se cerrarán. Tendrás que iniciar sesión otra vez.",
    "reset.ok": "Contraseña actualizada. Inicia sesión con tu nueva contraseña.",
    "reset.err.invalid": "Este enlace ya no es válido.",
    "reset.err.generic": "No se pudo guardar la nueva contraseña.",
  },
  en: {
    // Common
    "common.back": "Back",
    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.delete": "Delete",
    "common.create": "Create",
    "common.add": "Add",
    "common.edit": "Edit",
    "common.continue": "Continue",
    "common.confirm": "Confirm",
    "common.next": "Next",
    "common.previous": "Previous",
    "common.finish": "Finish",
    "common.loading": "Loading...",
    "common.generating": "Generating...",
    "common.empty": "No content yet.",
    "common.search": "Search",
    "common.profile": "Profile",
    "common.settings": "Settings",
    "common.welcome": "Welcome",
    "common.error": "Error",
    "common.success": "Done!",
    "common.coming_soon": "Soon",
    "common.see_more": "See more",
    "common.see_less": "See less",
    "common.try_again": "Try again",
    "common.close": "Close",
    "common.yes": "Yes",
    "common.no": "No",

    "brand.subtitle": "Furniture",
    "brand.title": "Canales · Academy",
    "topbar.admin_view": "Administrator View",
    "topbar.platform": "Training Platform",
    "topbar.admin_badge": "Admin",
    "topbar.ai_suggestion": "AI Suggestion",
    "topbar.language_toggle_aria": "Switch language",

    "sidebar.group.admin": "Administration",
    "sidebar.group.learning": "Learning",
    "sidebar.group.operations": "Operations",
    "sidebar.group.culture": "Culture & Strategy",
    "sidebar.group.people": "People",

    "nav.admin": "Dashboard",
    "nav.assignments": "Assignments · AI",
    "nav.dashboard": "Home",
    "nav.courses_admin": "Courses",
    "nav.library": "Library",
    "nav.processes": "Processes",
    "nav.community": "Community",
    "nav.languages": "Languages",
    "nav.languages_admin": "Languages (admin)",
    "nav.financing": "Financing",
    "nav.motivation": "Motivation",
    "nav.leadership": "Leadership",
    "nav.strategy": "Strategy",
    "nav.rewards": "Rewards",
    "nav.evaluations": "Evaluations",
    "nav.mgr_eval": "Manager Eval.",
    "nav.my_team": "My team",
    "nav.sms": "SMS notifs",

    "user.role.admin": "Administrator",
    "user.role.salesperson": "Salesperson",
    "user.logout": "Sign out",

    "lang.hero.eyebrow": "New module · Canales Language School",
    "lang.hero.title": "Learn languages by playing.",
    "lang.hero.subtitle":
      "Break the language barrier with customers in English, French or Spanish. Short lessons, characters that guide you, and points that count toward rewards.",
    "lang.feature.lessons": "9 lessons",
    "lang.feature.voice": "AI Voice Conversation",
    "lang.feature.streaks": "Daily streaks",
    "lang.feature.badges": "7 badges",
    "lang.section.guide.eyebrow": "Your guide",
    "lang.section.guide.title": "Pick your character",
    "lang.section.guide.note": "You can change it whenever you want.",
    "lang.section.catalog.eyebrow": "Catalog",
    "lang.section.catalog.title": "Pick a language",
    "lang.character.active": "Active",
    "lang.lessons_progress": "{completed}/{total} lessons",
    "lang.plan.eyebrow": "Your personalized plan",
    "lang.plan.coach_label": "Message from your coach",
    "lang.plan.minutes_per_week": "Min/wk",
    "lang.plan.lessons_per_week": "Lessons/wk",
    "lang.plan.next_lessons": "Next lessons",
    "lang.plan.scenario": "Scenario",
    "lang.plan.scenario_value": "AI Voice",
    "lang.plan.reconfigure": "Reconfigure my plan",

    "lang.hud.xp_total": "Total XP",
    "lang.hud.coins": "Coins",
    "lang.hud.streak": "Streak",
    "lang.hud.streak_days": "{n} day{plural}",
    "lang.hud.level": "Level {n}",
    "lang.hud.xp_to_next": "{xp} XP to level {next}",

    "lang.map.back": "Back to languages",
    "lang.map.title": "Your learning path",
    "lang.map.subtitle": "Each lesson has short exercises. Complete one to unlock the next.",
    "lang.map.world_label": "World {n}",
    "lang.map.world_complete": "Complete",
    "lang.map.lesson_label": "Lesson {n}",
    "lang.map.cta.eyebrow": "New · AI by voice",
    "lang.map.cta.title": "Talk to the AI in {lang}",
    "lang.map.cta.subtitle": "Speak. It replies. It corrects you instantly. Like a FaceTime with your coach.",
    "lang.map.world.ciudad": "The City",
    "lang.map.world.restaurante": "The Restaurant",
    "lang.map.world.viaje": "Travel",
    "lang.map.materials.eyebrow": "Curated by your team",
    "lang.map.materials.title": "Additional material",
    "lang.map.material.ai_exam": "AI exam at the end",
    "lang.map.material.completed": "Completed",

    "lesson.kind.translate_multiple": "Translate · multiple choice",
    "lesson.kind.listen_choose": "Listen and choose",
    "lesson.kind.type_answer": "Type the translation",
    "lesson.kind.match_pairs": "Match the words",
    "lesson.kind.order_words": "Order the words",
    "lesson.verify": "Check",
    "lesson.show_hint": "Show hint",
    "lesson.hide_hint": "Hide hint",
    "lesson.feedback.correct": "Correct!",
    "lesson.feedback.wrong": "Answer",
    "lesson.feedback.right_answer": "The correct answer is:",
    "lesson.listen_button": "Listen",
    "lesson.listen_help": "Your browser reads the word aloud. Tap to repeat.",
    "lesson.type_placeholder": "Type your answer...",
    "lesson.type_help": "We accept with or without accents.",
    "lesson.order_help": "Tap the words below in order...",
    "lesson.match.reset": "Reset",
    "lesson.coach.thinking": "Thinking of a hint for you...",

    "lesson.results.completed": "Lesson completed",
    "lesson.results.perfect": "Perfect!",
    "lesson.results.passed": "Well done!",
    "lesson.results.failed": "Keep practicing",
    "lesson.results.correct": "Correct",
    "lesson.results.accuracy": "Accuracy",
    "lesson.results.xp": "XP",
    "lesson.results.coins": "{n} coins",
    "lesson.results.streak": "Streak: {n} day{plural}",
    "lesson.results.global_pts": "{n} global pts",
    "lesson.results.new_badges": "New badges!",
    "lesson.results.world_complete": "🗺️ You completed an entire world!",
    "lesson.results.back": "Back to map",
    "lesson.results.retry": "Retry",
    "lesson.results.review": "View review ({n} exercises)",
    "lesson.results.your_answer": "Your answer:",
    "lesson.results.right_answer": "Correct:",
    "lesson.results.no_answer": "(no answer)",

    "conv.picker.eyebrow": "AI Conversation · Voice",
    "conv.picker.title": "Speak. The AI replies and corrects you.",
    "conv.picker.subtitle": "Choose a scenario, press the mic and converse in {lang} as if it were real. Your coach gives feedback instantly.",
    "conv.picker.tag_browser": "Web Speech (Chrome/Edge/Safari)",
    "conv.picker.tag_pts": "+20 global pts per session",
    "conv.picker.starting": "Starting with your coach...",
    "conv.chat.exit": "Exit",
    "conv.chat.end": "End and view summary",
    "conv.chat.eyebrow": "Conversation · {lang}",
    "conv.chat.subtitle": "Speak with your coach. They reply and correct you instantly.",
    "conv.chat.coach_lang": "Coach · in {lang}",
    "conv.chat.score": "Score:",
    "conv.chat.suggestions": "Reply suggestions",
    "conv.chat.recording": "Recording... speak clearly",
    "conv.chat.transcribed": "Got it. Tap send or record again.",
    "conv.chat.idle": "Tap the mic and say your answer.",
    "conv.chat.send": "Send",
    "conv.chat.no_mic": "No microphone?",
    "conv.chat.switch_text": "Type instead of speaking",
    "conv.chat.placeholder": "Type your answer...",
    "conv.chat.thinking": "Your coach is replying...",
    "conv.chat.voice_picker": "AI Voice",
    "conv.chat.voice_pick_label": "Choose the coach's voice",
    "conv.chat.voice_none": "Your browser did not expose voices for this language.",
    "conv.summary.eyebrow": "Session ended",
    "conv.summary.title": "Great job!",
    "conv.summary.turns": "Turns",
    "conv.summary.score": "Score",
    "conv.summary.xp": "XP",
    "conv.summary.global_pts": "+{n} global points",
    "conv.summary.strengths": "Strengths",
    "conv.summary.improve": "Improve",
    "conv.summary.back": "Back to map",

    "onb.step1.title": "How old are you?",
    "onb.step1.subtitle": "This helps us tailor the tone.",
    "onb.step2.title": "Which language do you want to practice?",
    "onb.step2.subtitle": "You can change it later.",
    "onb.step3.title": "What motivates you most?",
    "onb.step3.subtitle": "We'll adapt the practices to your goal.",
    "onb.step4.title": "How comfortable do you feel speaking?",
    "onb.step4.subtitle": "Be honest, there are no bad answers.",
    "onb.step5.title": "How many minutes per day can you practice?",
    "onb.step5.subtitle": "Small and consistent wins.",
    "onb.step6.title": "Pick your coach",
    "onb.step6.subtitle": "The character that will accompany you on your journey.",
    "onb.last_hint": "Last step. Your coach is getting ready for you.",
    "onb.helper": "Your answers create a unique plan in seconds.",
    "onb.cta.next": "Next",
    "onb.cta.generate": "Generate my plan",
    "onb.cta.generating": "Generating with AI...",
    "onb.plan.eyebrow": "AI-generated plan",
    "onb.plan.title": "Your path is ready.",
    "onb.plan.minutes_week": "Min/week",
    "onb.plan.lessons_week": "Lessons/week",
    "onb.plan.milestones": "Your first goals",
    "onb.plan.start": "Start my journey",

    "onb.opt.age.18-24": "18 to 24 years",
    "onb.opt.age.25-34": "25 to 34 years",
    "onb.opt.age.35-44": "35 to 44 years",
    "onb.opt.age.45+": "45 years or more",
    "onb.opt.lang.en": "🇺🇸 English",
    "onb.opt.lang.fr": "🇫🇷 French",
    "onb.opt.lang.es": "🇪🇸 Spanish",
    "onb.opt.motiv.atender_clientes": "Help foreign customers at the store 🛋️",
    "onb.opt.motiv.cerrar_ventas": "Close more sales with non-Spanish-speaking customers 💼",
    "onb.opt.motiv.viajar": "Travel and get around abroad ✈️",
    "onb.opt.motiv.curiosidad": "Personal curiosity and growth 🌱",
    "onb.opt.level.principiante": "Beginner · I'm starting from scratch",
    "onb.opt.level.intermedio": "Intermediate · I get by",
    "onb.opt.level.avanzado": "Advanced · I just want to polish",
    "onb.opt.minutes.5": "5 minutes · just enough",
    "onb.opt.minutes.10": "10 minutes · comfortable",
    "onb.opt.minutes.15": "15 minutes · focused",
    "onb.opt.minutes.30": "30 minutes · marathon",

    "mat.material": "Material",
    "mat.back_to_map": "Back to map",
    "mat.completed_label": "Material completed",
    "mat.completed_hint": "Ready to verify your comprehension with an AI exam?",
    "mat.start_quiz": "I'm done · AI exam · 15 questions",
    "mat.start_quiz_done": "Take AI exam · 15 questions",
    "mat.generating": "Generating AI exam...",
    "mat.open_external": "Open in new tab",
    "mat.open_link": "Open external link",
    "mat.quiz.eyebrow": "AI-generated exam",
    "mat.quiz.q_label": "Question {i}/{total}",
    "mat.quiz.answered_count": "{answered}/{total} answered",
    "mat.quiz.submit": "Submit exam",
    "mat.quiz.result.title.perfect": "Perfect!",
    "mat.quiz.result.title.passed": "You passed!",
    "mat.quiz.result.title.failed": "Keep studying",
    "mat.quiz.result.review": "View review ({n})",

    "section.daily_quote.label": "Quote of the day",
    "section.weekly.label": "Weekly reflection · AI",
    "section.empty.title": "No materials yet in {section}.",
    "section.empty.admin": "Upload the first material from the form above.",
    "section.empty.user": "The team will load content here soon.",
    "section.mark_read": "+5 pts",
    "section.read": "Read",
    "section.mark_read_title_done": "Read",
    "section.mark_read_title_undone": "Mark as read (+5 pts)",

    "adm_lang.eyebrow": "Languages · Additional material",
    "adm_lang.title": "Upload material for your team.",
    "adm_lang.subtitle":
      "Share PDFs, videos, links or notes by language. Salespeople will see them as \"Additional material\" on the language map. After finishing a video, the AI can generate a 15-question exam based on the summary.",
    "adm_lang.tab.en": "🇺🇸 English",
    "adm_lang.tab.fr": "🇫🇷 French",
    "adm_lang.tab.es": "🇪🇸 Spanish",
    "adm_lang.list_label": "Materials in {lang} · {n}",
    "adm_lang.empty": "No materials yet for this language. Upload the first one above.",
    "adm_lang.upload_in": "Upload material in {lang}",
    "adm_lang.field.title": "Title",
    "adm_lang.field.desc": "Short description (optional, helps generate the AI exam)",
    "adm_lang.field.body": "Note content...",
    "adm_lang.field.transcript_label": "Video summary / transcript (recommended)",
    "adm_lang.field.transcript_placeholder":
      "Paste here the summary or transcript of the video. The AI will generate a 15-question exam based on this text. If empty, questions will be general from the title and description.",
    "adm_lang.field.url_external": "URL https://...",
    "adm_lang.field.url_video": "URL https://... (YouTube, Vimeo, etc.)",
    "adm_lang.upload_choose": "Upload file",
    "adm_lang.upload_url": "External URL",
    "adm_lang.uploading": "Uploading...",
    "adm_lang.upload_done": "Done",
    "adm_lang.has_transcript": "Has transcript · AI exam ready",
    "adm_lang.type.video": "Video",
    "adm_lang.type.pdf": "PDF",
    "adm_lang.type.link": "Link",
    "adm_lang.type.note": "Note / text",
    "adm_lang.confirm_delete": "Delete this material? Its cached AI exam will also be removed.",

    // Evaluations (salesperson / admin)
    "eval.user.eyebrow": "Evaluations",
    "eval.user.title": "Your assigned exams.",
    "eval.user.subtitle": "Answer the exams your administrator assigned you. When you finish, you'll receive an AI summary with your strengths and areas to improve.",
    "eval.user.empty": "You don't have any evaluations assigned yet. When your admin assigns one, it will appear here.",
    "eval.user.pending": "Pending",
    "eval.user.completed": "Completed",
    "eval.user.no_pending": "Nothing pending. Well done!",
    "eval.user.pending_badge": "Pending",
    "eval.user.start": "Start",
    "eval.user.retake": "Retake",
    "eval.questions": "questions",
    "eval.question": "Question",
    "eval.runner.eyebrow": "Exam in progress",
    "eval.runner.answered": "Answered",
    "eval.submit": "Submit exam",
    "eval.confirm_unanswered": "You have {n} unanswered question(s). Submit anyway?",
    "eval.open_placeholder": "Type your answer here...",
    "eval.type.multiple_choice": "Multiple choice",
    "eval.type.scale": "Scale 1-5",
    "eval.type.open": "Open question",
    "eval.result.passed": "Passed! Great job.",
    "eval.result.failed": "Not passed. Review and try again.",
    "eval.result.qualitative": "Result recorded · qualitative evaluation",
    "eval.points_awarded": "points",
    "eval.ai_summary": "Personalized AI summary",
    "eval.strengths": "Strengths",
    "eval.to_improve": "To improve",
    "eval.review_details": "Per-question breakdown",
    "eval.correct": "Correct",
    "eval.incorrect": "Incorrect",
    "eval.answer_recorded": "Answer recorded",
    "eval.back_to_list": "Back to list",

    // Manager team dashboard
    "manager.team.eyebrow": "My team",
    "manager.team.title": "Your salespeople and their progress.",
    "manager.team.subtitle": "See at a glance how each salesperson reporting to you is doing: completed evaluations, average score, courses passed and AI summary from their last exam.",
    "manager.team.kpi_size": "Salespeople",
    "manager.team.kpi_evals": "Evals. completed",
    "manager.team.kpi_avg": "Team average",
    "manager.team.col_evals": "Evals.",
    "manager.team.col_avg": "Average",
    "manager.team.col_courses": "Courses OK",
    "manager.team.last_eval": "Last evaluation",
    "manager.team.list_label": "Team you lead",
    "manager.team.empty": "No salespeople assigned yet.",
    "manager.team.empty_hint": "Ask the admin to assign your team from Salespeople → Edit → Reports to.",

    // Salesperson dashboard widget · pending evaluations
    "widget.eval.eyebrow": "Your manager assigned you",
    "widget.eval.title": "{n} pending evaluation(s)",
    "widget.eval.subtitle": "Your manager is waiting for your results. Finish them to earn points and show progress.",
    "widget.eval.go": "Start",
    "widget.eval.manager": "For managers",

    // Admin SMS page
    "sms.eyebrow": "SMS notifications",
    "sms.title": "Real-time SMS alerts for leadership.",
    "sms.subtitle": "Every login, course completion and 100-point milestone fires an SMS to the configured numbers. Keeps leadership in the loop without opening the platform.",
    "sms.status_active": "Twilio active · sending real SMS",
    "sms.status_active_desc": "Twilio credentials are set. Every trigger sends a real SMS and is logged in the history below.",
    "sms.status_mock": "Mock mode · no Twilio credentials",
    "sms.status_mock_desc": "SMS are logged as 'mocked' but NOT actually sent. Add your Twilio credentials in backend/.env to activate:",
    "sms.on": "Enabled",
    "sms.off": "Paused",
    "sms.enabled": "SMS enabled",
    "sms.disabled": "SMS paused",
    "sms.kpi_sent": "Sent (real)",
    "sms.kpi_mocked": "Mocked",
    "sms.kpi_error": "Errors",
    "sms.recipients_label": "Recipients",
    "sms.recipients_title": "Who receives the alerts?",
    "sms.recipients_desc": "Each SMS goes to ALL numbers on the list. E.164 format (+ country + number, no spaces).",
    "sms.no_recipients": "No numbers configured. Add at least one for SMS to work.",
    "sms.add": "Add",
    "sms.remove": "Remove",
    "sms.format_hint": "Example: +19172663595 · spaces and dashes also accepted, they get normalized.",
    "sms.phone_added": "Number added",
    "sms.phone_removed": "Number removed",
    "sms.confirm_remove": "Remove this number from the alerts list?",
    "sms.test_label": "Quick test",
    "sms.test_title": "Send a test SMS to all numbers",
    "sms.send_test": "Send test",
    "sms.test_sent": "Test sent · check the history",
    "sms.history_label": "History · last 100 SMS",
    "sms.history_empty": "No SMS yet. Try logging in, completing a course or hit the test button.",
    "sms.col_time": "Time",
    "sms.col_kind": "Kind",
    "sms.col_to": "To",
    "sms.col_status": "Status",
    "sms.col_body": "Message",
    "sms.select_all": "Select all",
    "sms.select_row": "Select this row",
    "sms.delete_row": "Delete this log",
    "sms.delete_selected": "Delete selected",
    "sms.clear_selection": "Clear selection",
    "sms.clear_all": "Clear all",
    "sms.n_selected": "{n} selected",
    "sms.confirm_delete_one": "Delete this log from the history?",
    "sms.confirm_delete_bulk": "Delete {n} logs from the history?",
    "sms.confirm_clear_all": "Clear the ENTIRE SMS history? This cannot be undone.",
    "sms.deleted_one": "Log deleted",
    "sms.deleted_bulk": "{n} log(s) deleted",
    "common.refresh": "Refresh",

    // Login
    "login.eyebrow_left": "Internal Sales Academy",
    "login.hero_title": "Build salespeople who close with confidence.",
    "login.hero_subtitle": "A platform built to standardize training, measure floor mastery and lift every advisor's performance at Mueblería Canales.",
    "login.footer_left": "Internal Training",
    "login.team_access": "Team access",
    "login.welcome_back": "Welcome back.",
    "login.welcome_subtitle": "Sign in with your Google account to continue your training.",
    "login.google_btn": "Continue with Google",
    "login.or": "or",
    "login.admin_btn": "Administrator access with password",
    "login.help_text": "Salespeople sign in with Google. Administrators with institutional credentials use the \"Administrator access with password\" button.",
    "login.legal_prefix": "By signing in you accept the",
    "login.legal_and": "and the",
    "login.legal_suffix": "of the Mueblería Canales training platform.",
    "login.privacy_link": "Privacy Policy",
    "login.terms_link": "Terms & Conditions",

    // Admin Dashboard
    "admin.eyebrow": "Admin Panel",
    "admin.hero_title": "Sales team results.",
    "admin.hero_subtitle": "Create courses, upload videos and PDFs, configure exams and track every salesperson's progress.",
    "admin.team_eyebrow": "Team",
    "admin.team_heading": "Salespeople & progress",
    "admin.approvals": "Approvals",
    "admin.create_user": "Create user",

    // Manual PDF card
    "manual.eyebrow": "3 role-based manuals",
    "manual.title": "PDF Manuals",
    "manual.last_update": "Last update",
    "manual.locale_label": "PDF language",
    "manual.locale_hint": "Pick the language used for the manual body text and the screenshots.",
    "manual.step.seeding": "Seeding demo data...",
    "manual.step.capturing": "Capturing screens (≈40s)...",
    "manual.step.rendering": "Building PDF...",
    "manual.step.cleanup": "Cleaning up...",
    "manual.step_progress": "Step {step}/{total}",
    "manual.screenshots": "{n} shots",
    "manual.error_title": "Last rebuild failed",
    "manual.ok_ready": "Generated successfully",
    "manual.generating": "Generating...",
    "manual.rebuild_btn": "Rebuild the 3 PDFs ({lang})",
    "manual.rebuild_btn_title": "Rebuild by capturing the current UI in the selected language",
    "manual.confirm_rebuild": "Rebuild all 3 manuals in {lang} now?\n\nThis takes ~60 seconds: the system captures fresh screenshots in the chosen language and builds the PDFs. The current files stay available while the new ones are generated.",
    "manual.rebuild_started": "Rebuild started · ~60 seconds",
    "manual.rebuild_error": "Error starting rebuild",

    // Admin Settings (manual user creation)
    "settings.eyebrow": "Administrator settings",
    "settings.title": "Admin Settings",
    "settings.subtitle": "Hi {name}, from here you can manually add new users and assign their permissions. Each role has a predefined set of permissions.",
    "settings.you": "Signed in as",
    "settings.back": "Back to dashboard",
    "settings.add.title": "Add a new user",
    "settings.add.subtitle": "Complete the 3 steps below. Permissions are assigned automatically based on the role you pick.",
    "settings.step": "Step {n}",
    "settings.identity": "User details",
    "settings.field.role": "User role",
    "settings.field.name": "Full name",
    "settings.field.email": "Email address",
    "settings.field.password": "Initial password",
    "settings.field.password_hint": "At least 6 characters. Share it securely with the user.",
    "settings.field.phone": "Phone (optional, E.164 format)",
    "settings.field.phone_hint": "Used only for internal SMS notifications. Example: +18175551234.",
    "settings.field.reports_to": "Reports to (manager)",
    "settings.field.reports_to_hint": "If left empty, you can assign a manager later from the dashboard.",
    "settings.no_manager": "— No manager assigned for now —",
    "settings.regen": "Generate another",
    "settings.clear": "Clear",
    "settings.creating": "Creating...",
    "settings.add_btn": "Create as {role}",
    "settings.created_ok": "{name} was created successfully",
    "settings.created_eyebrow": "User created",
    "settings.created_role": "Assigned role",
    "settings.created_password": "Initial password",
    "settings.created_password_hint": "Copy it now — for security it won't be shown again.",
    "settings.creds_send_btn": "Send credentials by email",
    "settings.creds_send_hint": "The user will receive an email with their login and initial password. They can sign in right away.",
    "settings.creds_sending": "Sending...",
    "settings.creds_sent": "Credentials emailed to {email}",
    "settings.creds_mocked": "Email logged (mock mode · configure Resend to send for real)",
    "settings.creds_sent_badge": "Credentials email sent",
    "settings.creds_error": "Could not send credentials email",
    "settings.dismiss": "Dismiss",
    "settings.legend_eyebrow": "Available roles",
    "settings.legend_title": "What can each role do?",
    "settings.permissions_title": "Permissions assigned automatically",
    "settings.full_table_hint": "To view and edit existing users, open the dashboard.",
    "settings.go_to_dashboard": "Open dashboard",
    "settings.err.name": "Full name is required",
    "settings.err.email": "Invalid email. Use the format name@domain.com",
    "settings.err.password": "Password must be at least 6 characters",
    "settings.err.create": "Could not create the user",
    // Role descriptions
    "settings.role.admin.title": "Admin",
    "settings.role.admin.tagline": "Full control of the platform.",
    "settings.role.admin.legend": "Configures courses, evaluations, users, SMS and notifications. Unlimited access.",
    "settings.role.admin.perm_1": "Create, edit and delete courses, evaluations and materials.",
    "settings.role.admin.perm_2": "Create, edit and delete users (any role).",
    "settings.role.admin.perm_3": "Approve managers and configure SMS recipients.",
    "settings.role.admin.perm_4": "See global stats and AI summaries for the entire team.",
    "settings.role.manager.title": "Manager",
    "settings.role.manager.tagline": "Lead and coach salespeople.",
    "settings.role.manager.legend": "Sees their team's progress, receives AI-summary emails and takes courses as a salesperson.",
    "settings.role.manager.perm_1": "View \"My team\" with progress, averages and AI summaries.",
    "settings.role.manager.perm_2": "Receive an email automatically when a salesperson finishes an evaluation.",
    "settings.role.manager.perm_3": "Take courses, evaluations and earn points like any salesperson.",
    "settings.role.manager.perm_4": "No access to creating courses, users or configuration.",
    "settings.role.sales.title": "Sales",
    "settings.role.sales.tagline": "Learn, evaluate, earn points.",
    "settings.role.sales.legend": "Takes courses, submits evaluations, practices languages and redeems rewards.",
    "settings.role.sales.perm_1": "Take assigned courses and submit evaluations.",
    "settings.role.sales.perm_2": "Earn points and redeem catalog rewards.",
    "settings.role.sales.perm_3": "Practice languages with AI assistant and voice conversation.",
    "settings.role.sales.perm_4": "View their own progress and certificates.",

    // Dashboards section headers
    "dashboard.eyebrow.catalog": "Catalog",
    "dashboard.title.modules": "Training modules",
    "dashboard.kpi.available_courses": "Available courses",
    "dashboard.kpi.passed_courses": "Courses passed",
    "dashboard.kpi.exam_average": "Exam average",
    "dashboard.weak.eyebrow": "Areas to improve",
    "dashboard.weak.recommend": "We recommend reviewing:",
    "dashboard.empty_courses": "No courses available yet.",
    "dashboard.add_module": "Add module",
    "dashboard.loading_courses": "Loading courses...",
    "dashboard.hero.greeting": "Hi, {name}",
    "dashboard.hero.title": "Your training path.",
    "dashboard.hero.body": "Study the modules at your own pace, take the exams and track your progress on every key topic for the Mueblería Canales sales floor.",

    "admin.eyebrow.shortcuts": "Admin shortcuts",
    "admin.title.shortcuts": "Add content to other sections",
    "admin.eyebrow.catalog": "Catalog",
    "admin.title.catalog": "Training modules",
    "admin.eyebrow.recognition": "Recognition",
    "admin.title.top_sales": "Top salespeople",

    // Rewards section
    "rewards.eyebrow.history": "History",
    "rewards.title.my_redemptions": "My redemptions",
    "rewards.col.reward": "Reward",
    "rewards.col.points": "Points",
    "rewards.col.date": "Date",
    "rewards.col.status": "Status",

    // ContentHub section
    "content.eyebrow.materials": "Materials",
    "content.title.team_resources": "{section} · Team resources",

    // Change password page
    "pwd.title": "Change password",
    "pwd.current": "Current password",
    "pwd.current.placeholder_forced": "The one the admin shared with you",
    "pwd.new": "New password",
    "pwd.new.hint": "At least 6 characters. Use uppercase, numbers and symbols for extra security.",
    "pwd.confirm": "Confirm new password",
    "pwd.match_ok": "Passwords match",
    "pwd.save": "Save password",
    "pwd.saving": "Saving...",
    "pwd.cancel": "Cancel",
    "pwd.ok": "Password updated successfully",
    "pwd.err.too_short": "The new password must be at least 6 characters",
    "pwd.err.mismatch": "Passwords don't match",
    "pwd.err.same_as_current": "The new password must be different from the current one",
    "pwd.err.generic": "Could not update password",
    "pwd.strength.weak": "Weak",
    "pwd.strength.ok": "Acceptable",
    "pwd.strength.strong": "Strong",
    "pwd.forced.title": "First sign-in",
    "pwd.forced.subtitle": "For security, change the password shared by your administrator before continuing.",

    // Forgot password
    "forgot.title": "Reset password",
    "forgot.subtitle": "Enter your email and we'll send you a link to create a new password.",
    "forgot.email": "Email address",
    "forgot.submit": "Send link",
    "forgot.sending": "Sending...",
    "forgot.back": "Back to sign-in",
    "forgot.privacy": "For privacy, you'll always see this confirmation whether or not the account exists. If your email is registered, you'll get the link in a few minutes.",
    "forgot.err.email": "Enter a valid email",
    "forgot.sent.title": "Check your email",
    "forgot.sent.body": "If {email} matches a valid account, we just sent a link to create a new password. The link expires in 60 minutes.",
    "forgot.sent.hint": "Don't forget to check your spam folder if you don't see it in your inbox.",
    "forgot.resend": "Send to another email",
    "forgot.go_login": "Go to sign-in",

    // Reset password (token landing)
    "reset.title": "Create a new password",
    "reset.submit": "Save and continue",
    "reset.validating": "Validating link...",
    "reset.invalid.title": "Invalid or expired link",
    "reset.request_new": "Request a new one",
    "reset.notice": "Saving the new password will sign you out of all active sessions. You'll need to sign in again.",
    "reset.ok": "Password updated. Sign in with your new password.",
    "reset.err.invalid": "This link is no longer valid.",
    "reset.err.generic": "Could not save the new password.",
  },
};

const I18nContext = createContext({
  locale: DEFAULT_LOCALE,
  setLocale: () => {},
  t: (k) => k,
});

function interpolate(template, vars) {
  if (!vars) return template;
  return template.replace(/\{(\w+)\}/g, (_, k) => (vars[k] !== undefined ? vars[k] : `{${k}}`));
}

export function I18nProvider({ children }) {
  const [locale, setLocaleState] = useState(() => {
    if (ENGLISH_ONLY_MODE) return "en";
    if (typeof window === "undefined") return DEFAULT_LOCALE;
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved && SUPPORTED.includes(saved)) return saved;
    const browser = (navigator.language || "en").slice(0, 2).toLowerCase();
    return SUPPORTED.includes(browser) ? browser : DEFAULT_LOCALE;
  });

  const setLocale = useCallback((l) => {
    // In English-only mode, locale switching is disabled.
    if (ENGLISH_ONLY_MODE) return;
    if (!SUPPORTED.includes(l)) return;
    setLocaleState(l);
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, l);
      try {
        document.documentElement.lang = l;
      } catch (_) {}
    }
  }, []);

  // Keep a stale "es" value in localStorage from being respected when
  // the app is in English-only mode (clears it once on mount).
  useEffect(() => {
    if (ENGLISH_ONLY_MODE && typeof window !== "undefined") {
      try {
        window.localStorage.setItem(STORAGE_KEY, "en");
      } catch (_) {}
    }
  }, []);

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = locale;
    }
  }, [locale]);

  const t = useCallback(
    (key, vars) => {
      const localized = (dict[locale] && dict[locale][key]) || (dict[DEFAULT_LOCALE] && dict[DEFAULT_LOCALE][key]) || key;
      return interpolate(localized, vars);
    },
    [locale],
  );

  return <I18nContext.Provider value={{ locale, setLocale, t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}

export function useT() {
  return useI18n().t;
}

/** Read current locale synchronously (useful for non-React modules like axios interceptors). */
export function getCurrentLocale() {
  if (typeof window === "undefined") return DEFAULT_LOCALE;
  const saved = window.localStorage.getItem(STORAGE_KEY);
  return saved && SUPPORTED.includes(saved) ? saved : DEFAULT_LOCALE;
}

export const SUPPORTED_LOCALES = SUPPORTED;
